module.exports = {
  devEnv:"online",/*dev:开发版本，online：线上版本*/
  baseURL1:"https://w2-1166.tipian.com",/*测试-vue*/
  baseURL:"",/*正式*/
  baseMtURL1:"https://api-1166.tipian.com",/*测试-移动端预览*/
  baseMtURL:"",/*正式线上*/
  upgradeUrl:"https://denglu.tipian.com/price",/*升级会员vip*/ 
  apiAppid:"uoxkse45j0563605",/*api请求appid*/
  apiAppkey:"eJfaqwDLPNktIpQUQAoehPm6iLwW77sH",/*api请求appkey*/
  qiniuMediaDomain:"//nsj.tipian01.cn",/*七牛云注册的空间域名*/
  qiniuTimeKey:'8ea8a79bc1aa1388fcbbe59b3298ef880a995689',//七牛云时间防盗链备用key
  /** 高级编辑器演示资源：true=本地public目录 / false=七牛云 */
  geditLocalDemoAssets:false,
  /** 高级编辑器 dev 环境专用测试上传目录（七牛），其他模块不受影响 */
  geditUploadTestPrefix:'mbm_test_gedit/',
  /** 高级编辑器开发联调固定 id_key（修改 / 预览）；仅 devEnv=dev 时作为默认打开 */
  geditDevIdKey:'l5_UJoh',
  aliMainKey:'a4tfXWKVKkc4NyZx2hATkvKV4zkzjxtG',/*阿里云加密主key*/
  mianDomain1:'https://w2-1166.tipian.com',//主域名-w2环境
  mianDomain:'https://www.tipian.com',//主域名
  dengluDomain:'https://denglu.tipian.com',//个人中心域名
	h5Urls:{
    home:'/home',/*h5个人中心*/
    set:'/home/set',/*h5个人中心设置*/
    order:'/home/order',/*h5订单中心*/
  },
  aliOSS:{
  	region: 'oss-cn-shenzhen',
  	accessKeyId: 'LTAI5tKLwn8UHZUN4ZjLisoi',
  	accessKeySecret: 'nR4TRYvsphHSUPXxRgb4xh7oJYkzy7',
  	bucket: 'tipian-sys',
  	outDomain:'//mqrq.tipian01.cn',
	  secure:true,
	},
  aliOSSOther:{
  	region: 'oss-cn-shenzhen',
  	accessKeyId: 'LTAI5tKLwn8UHZUN4ZjLisoi',
  	accessKeySecret: 'nR4TRYvsphHSUPXxRgb4xh7oJYkzy7',
  	bucket: 'tipian-oss',
  	outDomain:'//file.tipian01.cn',
	  secure:true,
  }
}